import { CustomerIcon } from 'components/Atoms/Icon';
import { USER_LEVEL_TYPE } from 'constants/common';
import { lazy } from 'react';
import * as routeName from '../route-name';
import * as routePath from '../route-path';

const TeamManagement = lazy(() => import('modules/user/Team'));

export const userRoutes = [
  {
    path: routePath.TEAM,
    component: TeamManagement,
    exact: true,
    name: routeName.TEAM,
    showMenu: true,
    icon: CustomerIcon,
    defaultShow: true
  },
];
